import { Checkbox, Select } from 'antd'
import AntdAvatar from 'components/Avatar'
import Flex from 'components/Flex'
import AntdCheckbox from 'components/Form/Checkbox'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import {
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { EmptyElement } from '../UIComponents/CommonStyledDiv'

export const MultiSelect = styled(Select)`
  width: 100% !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #676e83;
  height: 48px;

  .ant-select-selector {
    display: flex;
    align-items: center;
    height: 48px !important;
    background-color: ${props =>
      props?.disabled
        ? COLORS.DISABLED_SECONDARY
        : props.backgroundcolor
        ? props.backgroundcolor
        : '#ffffff'} !important;
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: none !important;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      props?.mode === 'multiple' ? '#ebecee' : 'transparent'};
    color: ${COLORS.GREY_P_100};
  }
  :hover {
    background-color: transparent;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
`
export const OptionText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 0;
  color: #343e59;
`
export const StyledP = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.BLACK_36};
  margin-bottom: 0px;
`
export const CheckBoxGroup = styled(Checkbox.Group)``

export const StyledFlex = styled(Flex)`
  gap: 15px;
`

const { Option } = MultiSelect

const SelectCheckBox = ({
  mode = 'multiple',
  optionProp,
  placeholder,
  onChange,
  headingLabel,
  optionDivData,
  selectedValue,
  maxTagCount,
  nameParam = 'name',
  valueParam = 'value',
  isInterviewer,
  lastNameParam,
  optionLabelProp,
  ...rest
}) => {
  const [visible, setVisible] = useState(false)
  const selectRef = useRef(null)
  useEffect(() => {
    const handleDocumentClick = event => {
      if (
        event?.target &&
        selectRef?.current &&
        selectRef?.current instanceof HTMLElement &&
        selectRef?.current?.contains(event?.target)
      ) {
        setVisible(true) // Show the dropdown options if clicked on select
      }
    }

    document.addEventListener('click', handleDocumentClick)
    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [])

  const onMouseLeave = () => {
    if (optionDivData?.length <= 0) setVisible(false)
  }
  return (
    <EmptyElement onMouseLeave={onMouseLeave}>
      {headingLabel && <StyledP>{headingLabel}</StyledP>}
      <MultiSelect
        ref={selectRef}
        mode={mode}
        optionLabelProp={optionLabelProp}
        maxTagCount={maxTagCount}
        placeholder={placeholder}
        onChange={onChange}
        open={visible}
        onClick={() => setVisible(true)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        suffixIcon={<SelectArrowIcon />}
        {...rest}
      >
        {optionDivData?.length &&
          optionDivData?.map((data, index) => (
            <Option
              style={{
                background: selectedValue?.includes(data?.id)
                  ? COLORS.GREY_S_96
                  : '#fff',
                borderRadius: '8px',
                alignItems: 'center',
                margin: '2px 5px',
              }}
              key={index + data[valueParam]}
              value={data[valueParam]}
              label={
                isInterviewer
                  ? `${data[nameParam]} ${data[lastNameParam]}`
                  : data[nameParam]
              }
              id={data[valueParam]}
              firstName={data[nameParam]}
              lastName={data[lastNameParam]}
              disabled={!isInterviewer && data[nameParam] === 'Student Id'}
            >
              {!isInterviewer ? (
                <CheckBoxGroup value={selectedValue}>
                  <Flex centerVertically style={{ gap: '15px' }}>
                    <AntdCheckbox
                      value={data[valueParam]}
                      disabled={data[nameParam] == 'Student Id'}
                    />
                    <OptionText style={{ marginBottom: 0 }}>
                      {data[nameParam]}
                    </OptionText>
                  </Flex>
                </CheckBoxGroup>
              ) : (
                <CollageDetailsFlex
                  key={index + data?.first_name}
                  spaceBetween
                  centerVertically
                  idBoarder={optionDivData?.length - 1 === index}
                >
                  <Flex alignCenter spaceBetween>
                    <Flex>
                      <AntdAvatar
                        size={36}
                        IconName={data?.first_name?.charAt(0)?.toUpperCase()}
                      />

                      <CollageNameFlex>
                        <CollegeNameDiv>{`${data?.first_name} ${data?.last_name}`}</CollegeNameDiv>
                        <CollegeCity>{data.email}</CollegeCity>
                      </CollageNameFlex>
                    </Flex>
                  </Flex>
                </CollageDetailsFlex>
              )}
            </Option>
          ))}
      </MultiSelect>
    </EmptyElement>
  )
}

export default SelectCheckBox
